import { Container, Row, Col, Button } from 'react-bootstrap'
import logoAssessoria from '../assets/images/logo_blackstarassessoria.jpg'
import logoDesign from '../assets/images/logo_blackstardesign.jpg'
import logoVideos from '../assets/images/logo_blackstarvideos.jpg'
import logoFotos from '../assets/images/logo_blackstarfotos.jpg'

function ImageButton() {
  const elements = [
    {
      title: 'ASSESSORIA',
      text: 'Planejamento Estratégico de Marketing como principal pilar, e Marketing Digital, Comunicação Corporativa, Branding e Identidade Visual, Publicidade e Propaganda, Criação de Campanhas Publicitárias, Ativação de marca, Cobertura e Execução de Eventos, Trade Marketing, Live Marketing, Relações Públicas, Content Marketing, Produção de Conteúdo, Inbound Marketing, Marketing de Performance, Marketing de Produto.',
      image: logoAssessoria,
      link: 'https://www.instagram.com/assessoriablackstar/'
    },
    {
      title: 'DESIGN',
      text: 'Google Ads, Instagram ADS, LinkedIn ADS, Facebook ADS, Mídia Programática, Otimização de campanhas, Google Analytics, Análise e Otimizações de SEO, Análise de dados e relatórios de performance digital, testes A/B de campanhas digitais, Gestão de funil de vendas online, Lançamento de Infoprodutos, Design Orientado a Conversões.',
      image: logoDesign,
      link: 'https://www.instagram.com/designblackstar/'
    },
    {
      title: 'VÍDEOS',
      text: 'Desenvolvemos todo material online e offline da sua empresa. Marca, logotipo, identidade visual, catálogo, portfólio, folder, comunicação de PDV, apresentação corporativa e promocional, anúncio, banners, cartão digital, embalagem, papelaria, sinalização, fachadas e muito mais.',
      image: logoVideos,
      link: 'https://www.instagram.com/blackstarvideos/'
    },
    {
      title: 'FOTOS',
      text: 'Desenvolvemos todos os tipos de site, com layout personalizado e responsivo; Ecommerce, landing page, hotsite, portal corporativo, blog, projetos com foco em mobile, projetos especiais, otimização web (SEO), e-mail marketing, remarketing e etc.',
      image: logoFotos,
      link: 'https://www.instagram.com/blackstarfotos/'
    }
  ]

  return (
    <Container>
      <Row className='highlights-row'>
        <span className='cloister-black' style={{ color: '#FFF', fontSize: '60px' }}>Nossos Portfólios</span>
        {elements.map((element, index) => (
          <Col key={index} xs={12} sm={12} md={12} lg={3}>
            <Row className='h-100 highlights-row-internal'>
              <Col xs={12} sm={12} md={12} lg={12} className='highlights-col d-flex flex-column justify-content-center align-items-center'>
                <span className='suse' style={{ fontSize: '24px' }}>
                  {element.title}
                </span>
                <span style={{ padding: '20px' }}>
                  <img src={element.image} alt='' />
                </span>
                <span>
                  <Button href={element.link} target='_blank' className='button-primary-color'>VER PORTFÓLIO</Button>
                </span>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default ImageButton